/**
 * Check if the user has any pending invitations
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasInvitations = (state) => {
    return state.myInvites.data.length > 0
}

/**
 * Determine if the state contains sent invitatins
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasSentInvitations = (state) => {
    return state.sentInvites.data.length > 0
}

/**
 * My invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
const invitationCount = (state) => {
    return state.myInvites.data.length
}

/**
 * My sent invitation count
 *
 * @param  {Object} state
 * @return {Number}
 */
const sentInvitationCount = (state) => {
    return state.sentInvites.data.length
}

export default {
    hasInvitations,
    invitationCount,
    hasSentInvitations,
    sentInvitationCount
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/invitations/getters.js